module.exports = __webpack_public_path__ + "static/8-d1164cf6560e95217139bf5cd7e004c6.png";